<template>
    <div class="container">
        <section class="section">
            <div class="s-title">
                <h2>数据统计</h2>
                <div class="subtitle">当前数据显示个人（包含个人所管理的部门以及人员）的数据总和</div>
            </div>
            <a-divider />

            <div class="s-title">
                <h2>店铺新增</h2>
            </div>
            <a-row :gutter="16" class="items">
                <a-col :xs="12" :sm="6" :md="4" :lg="4" :xl="3" :xxl="2" class="item pointer" @click="on_detail('today')">
                    <a-statistic title="今天" :value="data_summary.add_today" />
                </a-col>
                <a-col :xs="12" :sm="6" :md="4" :lg="4" :xl="3" :xxl="2" class="item pointer" @click="on_detail('yest')">
                    <a-statistic title="昨天" :value="data_summary.add_yest" />
                </a-col>
                <a-col :xs="12" :sm="6" :md="4" :lg="4" :xl="3" :xxl="2" class="item pointer" @click="on_detail('week')">
                    <a-statistic title="本周" :value="data_summary.add_week" />
                </a-col>
                <a-col :xs="12" :sm="6" :md="4" :lg="4" :xl="3" :xxl="2" class="item pointer" @click="on_detail('last_week')">
                    <a-statistic title="上周" :value="data_summary.add_last_week" />
                </a-col>
                <a-col :xs="12" :sm="6" :md="4" :lg="4" :xl="3" :xxl="2" class="item pointer" @click="on_detail('month')">
                    <a-statistic title="本月" :value="data_summary.add_month" />
                </a-col>
                <a-col :xs="12" :sm="6" :md="4" :lg="4" :xl="3" :xxl="2" class="item pointer" @click="on_detail('last_month')">
                    <a-statistic title="上月" :value="data_summary.add_last_month" />
                </a-col>
            </a-row>
            <a-divider />

            <div class="s-title">
                <h2>店铺总计</h2>
            </div>
            <a-row :gutter="16" class="items">
                <a-col :xs="12" :sm="6" :md="4" :lg="4" :xl="3" :xxl="2" class="item pointer" @click="on_detail('')">
                    <a-statistic title="全部店铺" :value="data_summary.total" />
                </a-col>

                <a-col :xs="12" :sm="6" :md="4" :lg="4" :xl="3" :xxl="2" class="item">
                    <a-statistic title="已上架" :value="data_summary.total_online" />
                </a-col>

                <a-col :xs="12" :sm="6" :md="4" :lg="4" :xl="3" :xxl="2" class="item pointer" @click="on_detail('offline')">
                    <a-statistic title="已下架" :value="data_summary.total_offline" />
                </a-col>

                <a-col :xs="12" :sm="6" :md="4" :lg="4" :xl="3" :xxl="2" class="item">
                    <a-statistic title="交易中" :value="data_summary.trading" />
                </a-col>

                <a-col :xs="12" :sm="6" :md="4" :lg="4" :xl="3" :xxl="2" class="item">
                    <a-statistic title="已出售" :value="data_summary.sold" />
                </a-col>
            </a-row>
        </section>

        <section class="section">
            <h2>快捷操作</h2>
            <a-divider />

            <a-row :gutter="16" class="items">
                <a-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6" :xxl="4" class="item" @click="visible_force = true">
                    <a-card size="small" hoverable class="module-shortcut">
                        <div class="a">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#icon-LinkInsight" />
                            </svg>

                            <div class="detail">
                                <div class="title">强制修改店铺信息</div>
                            </div>
                        </div>
                    </a-card>
                </a-col>
            </a-row>
        </section>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                visible_force: false,
                data_summary: {
                    total: 0,
                    online_today: 0,
                    total_offline: 0,
                    total_online: 0,
                    trading: 0,
                    sold: 0,
                },
            };
        },
        created() {
            this.$store.commit("change_state", {
                name: "resource_sidebar_selected",
                value: "resource",
            });
 
            //this.load_summary();
        },
        methods: {
            load_summary() {
                this.$http.get(`/resource/summary`).then((res) => {
                    if (res.success) {
                        this.data_summary = res.data;
                    }
                });
            },
            on_detail(e) {
                if (!this.data_summary.data_scope) {
                    return false;
                }
                var query = {};
                switch (e) {
                    case "today":
                        query["created_at_gte"] = moment().format("YYYY-MM-DD 00:00:00");
                        query["created_at_lte"] = moment().format("YYYY-MM-DD 23:59:59");

                        break;
                    case "yest":
                        query["created_at_gte"] = moment(new Date())
                            .add(-1, "days")
                            .format("YYYY-MM-DD 00:00:00");
                        query["created_at_lte"] = moment(new Date())
                            .add(-1, "days")
                            .format("YYYY-MM-DD 23:59:59");
                        break;
                    case "week":
                        query["created_at_gte"] = moment()
                            .startOf("week")
                            .format("YYYY-MM-DD 00:00:00");
                        query["created_at_lte"] = moment()
                            .endOf("week")
                            .format("YYYY-MM-DD 23:59:59");
                        break;
                    case "last_week":
                        query["created_at_gte"] = moment(new Date())
                            .add(-1, "weeks")
                            .format("YYYY-MM-DD 00:00:00");
                        query["created_at_lte"] = moment(new Date())
                            .endOf("week")
                            .subtract("week", 1)
                            .format("YYYY-MM-DD 23:59:59");
                        break;
                    case "month":
                        query["created_at_gte"] = moment()
                            .startOf("month")
                            .format("YYYY-MM-DD 00:00:00");
                        query["created_at_lte"] = moment()
                            .endOf("month")
                            .format("YYYY-MM-DD 23:59:59");
                        break;
                    case "last_month":
                        query["created_at_gte"] = moment(new Date())
                            .add(-1, "months")
                            .format("YYYY-MM-DD 00:00:00");
                        query["created_at_lte"] = moment(new Date())
                            .endOf("month")
                            .subtract("month", 1)
                            .format("YYYY-MM-DD 23:59:59");
                        break;
                    case "offline":
                        query["status2"] = "offline";
                        break;
                }

                this.$router.push(`/resource/${this.data_summary.data_scope}?${this.objectToQuery(query)}`);
            },
        },
    };
</script>
<style lang="less" scoped>
    .container {
        padding: 16px;
        .items {
            .item {
                margin-bottom: 16px;
            }
        }
        .section {
            margin: 0 24px 48px 24px;
            .s-title {
                margin-bottom: 12px;
                h2 {
                    margin-bottom: 4px;
                }
                .subtitle {
                    color: #9e9e9e;
                    font-size: 12px;
                }
            }
        }
    }
</style>
